export default __webpack_public_path__ + "static/media/logo_lider_3.646c6f30.jpg";